/* oxlint-disable */
'use client';

import { memo, useCallback } from 'react';

import { CarouselContentSubType } from '@/features/cms/interface';
import { useRedirectGame } from '@/features/v2/shared/hooks/casinoHooks/useRedirecGame';
import { RollingGallery } from '@/stories/organisms/carousel/decorativeCarousel/DecorativeCarousel';
import { CardData } from '@/stories/organisms/carousel/decorativeCarousel/interface';

import { CarouselSectionProps } from './interface';

function CarouselSection({
  cards,
  subType,
  showDots = false,
  children = null
}: CarouselSectionProps) {
  const { handleGameRedirect } = useRedirectGame();

  const handleCardClick = useCallback((card: CardData) => {
    if (subType === CarouselContentSubType.CASINO && 'gameData' in card && card.gameData) {
      const categoryValue = 'category' in card ? card.category || 'casino' : 'casino';
      const gameItem = {
        identifier: card.gameData.identifier,
        provider: card.gameData.provider,
        title: card.gameData.title,
        producer: card.gameData.producer,
        category: categoryValue,
        usd_only: Boolean(card.gameData.usd_only),
        sections: card.gameData.sections || {}
      };

      handleGameRedirect({
        item: gameItem,
        categorySelected: categoryValue,
        gameIndex: 0
      });
    }
  }, [subType, handleGameRedirect]);

  return (
    <section className="h-full flex flex-col justify-center max-w-screen mx-auto overflow-hidden font-text md:bg-[radial-gradient(100%_57.03%_at_50%_50%,rgba(62,11,107,0.3)_0%,rgba(62,11,107,0)_100%)]">
      {children}
      <RollingGallery
        cards={cards}
        cardType={subType === CarouselContentSubType.CASINO ? 'casino' : 'decorative'}
        onCardClick={subType === CarouselContentSubType.CASINO ? handleCardClick : undefined}
      />
    </section>
  );
}

export const CarouselSectionMemo = memo(CarouselSection);
export { CarouselSectionMemo as CarouselSection };
